/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppState } from "src/contexts/AppContext";
import * as api from "src/api/request";

const LeftSidebar = () => {
  const { state, dispatch } = useAppState();
  // useEffect(() => {
  //   console.log('state.sidemenulist', state.sidemenulist)
  // }, [state.sidemenulist]);
  useEffect(() => {
    api.getMenu().then((res) => {
      dispatch({ type: "LOAD_LIST", data: res.data });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="app-sidebar__overlay" data-toggle="sidebar" />
      <aside className="main-sidebar app-sidebar sidebar-scroll">
        <div className="main-sidebar-header">
          <a href="/">
            <img src="/img/brand/CELogo52xx.png" className="main-logo" alt="" />
          </a>

          <Link className="icon-logo active" to="/">
            <img src="/img/brand/favicon2.png" className="logo-icon" alt="" />
          </Link>
          <Link className="desktop-logo logo-dark active" to="/">
            <img
              src="/img/brand/logo-white.png"
              className="main-logo dark-theme"
              alt="logo"
            />
          </Link>
          <Link className="logo-icon mobile-logo icon-dark active" to="/">
            <img
              src="/img/brand/favicon-white.png"
              className="logo-icon dark-theme"
              alt="logo"
            />
          </Link>
        </div>

        <div className="main-sidebar-loggedin mb-2"></div>
        <div className="main-sidebar-body">
          <ul className="side-menu">
            {state.sidemenulist.map((i) => {
              return (
                <li
                  className="slide"
                  key={i.id}
                  onClick={() =>
                    dispatch({ type: "SIDEMENU_CLICKED", data: i })
                  }
                >
                  <Link
                    className={
                      state.sidemenuclicked?.id === i.id
                        ? "side-menu__item active"
                        : "side-menu__item"
                    }
                    to={"/"}
                  >
                    <i className="side-menu__icon fe fe-airplay" />
                    <span className="side-menu__label">{i.group_name}</span>
                  </Link>
                </li>
              );
            })}
            {state.isexternal === 0 ? (
              <li className="slide">
                <Link className="side-menu__item" to={"/help"}>
                  <i className="side-menu__icon fe fe-airplay" />
                  <span className="side-menu__label">Тусламж</span>
                </Link>
              </li>
            ) : (
              ""
            )}
          </ul>

          <div className="card">
            <div className="d-flex justify-content-between pl-3 pt-3 pr-3 pb-0">
              {/* <h4 className="card-title">Гар утасны хувилбар</h4> */}
              <i className="mdi mdi-dots-vertical"></i>
            </div>
            {/* <p className="tx-12 tx-gray-500 mb-2 pl-3 pb-1 pr-3">
              Гар утасны хувилбар
              <a href="">Learn more</a>
            </p> */}
            <div className="card-body pt-0">
              <table className="table card-table country-table mb-0 border">
                <tbody>
                  <tr>
                    <td>
                      <Link to={"/links"} target="_blank">
                        <img
                          src="/img/qr/qr-tr.png"
                          alt="EMCQR"
                          className="flag wd-200 ht-170 flag-us mt-1"
                        />
                      </Link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default React.memo(LeftSidebar);
